const CONTENT_TYPES = {
  BOOTCAMP: 'bootcamp',
  COURSE: 'course',
  EXERCISE: 'exercise',
  IFRAME: 'iframe',
  LAB: 'lab',
  LEARNING_PATH: 'learning-path',
  QUIZ: 'quiz',
  SLIDES: 'slides',
  VIDEO: 'video',
}

// taxonomy_path: domain -> subdomain -> skill area -> skill
// levels:        0          1            2           3
// content types mapped to their skill level in the taxonomy path
const CONTENT_TYPE_SKILL_LEVELS = {
  [CONTENT_TYPES.COURSE]: 2,
  [CONTENT_TYPES.LEARNING_PATH]: 1,
  [CONTENT_TYPES.LAB]: 3,
  [CONTENT_TYPES.VIDEO]: 3,
}

const CONTENT_TYPE_SKILL_LABELS = {
  [CONTENT_TYPES.COURSE]: 'Taxonomy skill areas',
  [CONTENT_TYPES.LEARNING_PATH]: 'Taxonomy subdomains',
  [CONTENT_TYPES.LAB]: 'Taxonomy skills',
  [CONTENT_TYPES.VIDEO]: 'Taxonomy skills',
}

const SKILL_LEVELS = {
  DOMAIN: 0,
  SUBDOMAIN: 1,
  SKILL_AREA: 2,
  SKILL: 3,
  INVALID_SKILL_LEVEL: -1,
}

const CERTIFICATION_STATUSES = {
  DRAFT: 'draft',
  COMING_SOON: 'coming_soon',
  PUBLISHED: 'published',
  UNPUBLISHED: 'unpublished',
}

const CERTIFICATION_EXAM_TYPES = {
  BY_OBJECTIVE: 'by_objective',
  BY_QUESTION_CATEGORY: 'by_question_category',
}

const CERTIFICATION_GRADING_TYPES = {
  REGULAR: 'regular',
  PER_QUESTION_WEIGHT: 'per_question_weight',
}

const EDIT_ROUTE_BY_TYPE = {
  Course: 'edit-course',
  Video: 'edit-video',
  Quiz: 'edit-quiz',
  Pass: 'edit-pass',
  Lab: 'edit-lab',
  Exercise: 'edit-exercise',
  iFrame: 'edit-iframe',
  Bootcamp: 'edit-bootcamp',
  Collection: 'edit-collection',
  'Learning Path': 'edit-lp',
  'Skill Sonar': 'edit-sonar',
  CertificationVersions: 'certification-versions',
  CertificationVersionHistory: 'certification-version-edit',
}


const CONSTANTS = {
  CONTENT_TYPES,
  CONTENT_TYPE_SKILL_LEVELS,
  CONTENT_TYPE_SKILL_LABELS,
  SKILL_LEVELS,
  CERTIFICATION_STATUSES,
  CERTIFICATION_EXAM_TYPES,
  CERTIFICATION_GRADING_TYPES,
  EDIT_ROUTE_BY_TYPE,
}

export default CONSTANTS
